import React, { useEffect, useState } from "react";
import styles from "./Content.module.css";
import Navigation from "./Navigation/Navigation";
import ItemCard from "./Item/ItemCard";
import Skeleton from "../Skeleton/Skeleton";
import DeliveryModal from "../Modal/DeliveryModal/DeliveryModal";
import { useSelector } from "react-redux";
import Preview from "../Preview/Preview";

function Content(props) {
  const itemCard = props.isLoading
    ? [...new Array(6)].map((_, index) => <Skeleton key={index} />)
    : props.item.map((meal) => (
        <ItemCard
          key={meal.id}
          id={meal.id}
          name={meal.name}
          img={meal.img}
          description={meal.description}
          price={meal.price}
          weight={meal.weight}
          categoryName={meal.categoryName}
          addressCity={props.addressCity.BD}
          souse={props.souse}
        />
      ));

  return (
    <main className={styles.content}>
      <Navigation
        navigation={props.navigation}
        addressCity={props.addressCity}
      />
      <section className={styles.container}>{itemCard}</section>
    </main>
  );
}

export default Content;
